import { useQuery } from "@tanstack/react-query";
import type { UseQueryOptions } from "@tanstack/react-query";

import type { CosignMetaBody } from "@/core/types";

import { cosignatureKeys } from "../keyFactory";
import { getNoteCosignMeta } from "../queryFunctions/getNoteCosignMeta";

type UseNoteCosignMetaProps<TData = CosignMetaBody> = {
  documentId: string;
  enabled?: boolean;
  select?: (data: CosignMetaBody) => TData;
};

type NoteCosignMetaQueryOptions = UseQueryOptions<
  CosignMetaBody,
  unknown,
  CosignMetaBody,
  ReturnType<typeof cosignatureKeys.noteMeta>
>;

export function optionFactory(documentId: string, enabled = true) {
  return {
    enabled,
    queryFn: () => getNoteCosignMeta(documentId),
    queryKey: cosignatureKeys.noteMeta(documentId),
  } satisfies NoteCosignMetaQueryOptions;
}

export function useNoteCosignMeta<TData = CosignMetaBody>({
  documentId,
  enabled,
  select,
}: UseNoteCosignMetaProps<TData>) {
  return useQuery({ ...optionFactory(documentId, enabled), select });
}
